import * as Cesium from "cesium";
import type { DrawingMode } from "../types";

export function createCesiumDrawing(viewer: any, mode: DrawingMode) {
  let handler: any;

  return {
    activate() {
      console.log("Activating Cesium drawing mode:", viewer, mode);

      handler = viewer.screenSpaceEventHandler?.createScreenSpaceHandler();

      handler.setInputAction((click: any) => {
        const cartesian = viewer.scene?.pickPosition(click.position);
        viewer.drawingTool?.addPoint(cartesian);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },

    deactivate() {
      if (handler) handler.destroy();
    },
  };
}
